import React from 'react';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const CulturalPreferencesStep = ({ formData, onChange, errors }) => {
  const languageOptions = [
    { value: 'english', label: 'English' },
    { value: 'spanish', label: 'Spanish' },
    { value: 'mandarin', label: 'Mandarin' },
    { value: 'hindi', label: 'Hindi' },
    { value: 'arabic', label: 'Arabic' },
    { value: 'french', label: 'French' },
    { value: 'german', label: 'German' },
    { value: 'japanese', label: 'Japanese' },
    { value: 'korean', label: 'Korean' },
    { value: 'portuguese', label: 'Portuguese' }
  ];

  const culturalBackgroundOptions = [
    { value: 'african', label: 'African' },
    { value: 'asian', label: 'Asian' },
    { value: 'caucasian', label: 'Caucasian' },
    { value: 'hispanic-latino', label: 'Hispanic/Latino' },
    { value: 'indian', label: 'Indian' },
    { value: 'indigenous', label: 'Indigenous' },
    { value: 'middle-eastern', label: 'Middle Eastern' },
    { value: 'pacific-islander', label: 'Pacific Islander' },
    { value: 'mixed', label: 'Mixed/Multiple' },
    { value: 'prefer-not-to-say', label: 'Prefer not to say' }
  ];

  const religionOptions = [
    { value: 'buddhism', label: 'Buddhism' },
    { value: 'christianity', label: 'Christianity' },
    { value: 'hinduism', label: 'Hinduism' },
    { value: 'islam', label: 'Islam' },
    { value: 'judaism', label: 'Judaism' },
    { value: 'sikhism', label: 'Sikhism' },
    { value: 'spiritual', label: 'Spiritual but not religious' },
    { value: 'atheist', label: 'Atheist/Agnostic' },
    { value: 'other', label: 'Other' },
    { value: 'prefer-not-to-say', label: 'Prefer not to say' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Cultural & Language Preferences
        </h3>
        <p className="text-sm text-muted-foreground">
          Connect with helpers who understand your cultural context
        </p>
      </div>
      <Select
        label="Preferred Language(s)"
        placeholder="Select language(s)"
        options={languageOptions}
        value={formData?.languages || []}
        onChange={(value) => onChange('languages', value)}
        multiple
        searchable
        description="Select all languages you're comfortable speaking"
        required
        error={errors?.languages}
      />
      <Select
        label="Cultural Background"
        placeholder="Select your cultural background"
        options={culturalBackgroundOptions}
        value={formData?.culturalBackground || ''}
        onChange={(value) => onChange('culturalBackground', value)}
        description="Optional - helps match with culturally aware helpers"
        error={errors?.culturalBackground}
      />
      <Select
        label="Religious/Spiritual Background"
        placeholder="Select if applicable"
        options={religionOptions}
        value={formData?.religion || ''}
        onChange={(value) => onChange('religion', value)}
        description="Optional - for matching with helpers who respect your beliefs"
        error={errors?.religion}
      />
      <div className="space-y-3">
        <label className="text-sm font-medium text-foreground">
          Cultural Matching Preferences
        </label>
        <Checkbox
          label="I prefer a helper who shares my cultural background"
          checked={formData?.preferSameCulture || false}
          onChange={(e) => onChange('preferSameCulture', e?.target?.checked)}
          description="We'll prioritize helpers from similar backgrounds"
        />
        <Checkbox
          label="I'm open to helpers from any cultural background"
          checked={formData?.openToAnyCulture || false}
          onChange={(e) => onChange('openToAnyCulture', e?.target?.checked)}
          description="Expands your matching options"
        />
      </div>
      <div className="p-4 bg-primary/5 rounded-lg border border-primary/20">
        <p className="text-sm text-foreground">
          <strong>Cultural Sensitivity:</strong> All helpers are trained in cultural competency and respect diverse backgrounds. Your preferences help us provide the most comfortable experience.
        </p>
      </div>
    </div>
  );
};

export default CulturalPreferencesStep;